module.exports = __webpack_public_path__ + "img/bg_mask.beceb0e3.png";